import React from "react";
import SidebarAccountMenu from "./SidebarAccountMenu";
import polarisLogo from "../images/Polaris Logo.svg";
import polarisAthleteLogo from "../images/banner/polaris-logo.svg";
import "../styles/rail-sidebar.css";
import "../styles/athlete-wide-rail.css";

export type RailSidebarShellProps = {
    headerLogoUrl?: string | null;
    /** Changes force the header <img> to remount after logo upload/replace. */
    headerLogoKey?: string | number;
    footerAvatarUrl?: string | null;
    footerAvatarAlt?: string;
    /** When true, show logout confirm modal (default true). */
    confirmLogout?: boolean;
    /** When true, show Community Forum in the account menu (staff/admin). */
    showSubmitIdea?: boolean;
    /** When true, show Get Support in the account menu. */
    showRaiseTicket?: boolean;
    /** When true, show Help Articles in the account menu. */
    showGettingStarted?: boolean;
    onHeaderLogoError?: () => void;
    className?: string;
    "data-testid"?: string;
    children: React.ReactNode;
};

export default function RailSidebarShell({
    headerLogoUrl,
    headerLogoKey,
    footerAvatarUrl,
    footerAvatarAlt,
    confirmLogout = true,
    showSubmitIdea = false,
    showRaiseTicket = true,
    showGettingStarted = true,
    onHeaderLogoError,
    className = "",
    "data-testid": dataTestId,
    children,
}: RailSidebarShellProps) {
    const hasCompanyLogo = Boolean(headerLogoUrl);
    // Same mark BrandBanner always showed when no company logo was uploaded.
    const headerSrc = headerLogoUrl || polarisLogo;

    return (
        <aside
            className={`sidebar rail-sidebar ${className}`.trim()}
            data-testid={dataTestId}
        >
            <div
                className={
                    hasCompanyLogo
                        ? "sidebar-rail-header sidebar-rail-header--company"
                        : "sidebar-rail-header sidebar-rail-header--polaris"
                }
            >
                <img
                    key={hasCompanyLogo ? `company-${headerLogoKey ?? headerSrc}` : "polaris-fallback"}
                    src={headerSrc}
                    alt={hasCompanyLogo ? "Company logo" : "Polaris"}
                    className={
                        hasCompanyLogo
                            ? "sidebar-rail-header-logo"
                            : "sidebar-rail-header-logo sidebar-rail-header-logo--polaris"
                    }
                    data-testid="sidebar-rail-header-logo"
                    onError={hasCompanyLogo ? onHeaderLogoError : undefined}
                />
            </div>

            <div className="sidebar-rail-nav">{children}</div>

            <div className="sidebar-rail-footer">
                <SidebarAccountMenu
                    footerAvatarUrl={footerAvatarUrl}
                    footerAvatarAlt={footerAvatarAlt}
                    confirmLogout={confirmLogout}
                    showSubmitIdea={showSubmitIdea}
                    showRaiseTicket={showRaiseTicket}
                    showGettingStarted={showGettingStarted}
                />
                <img
                    src={polarisAthleteLogo}
                    alt="Polaris Athlete"
                    className="sidebar-rail-wordmark"
                    data-testid="sidebar-rail-wordmark"
                />
            </div>
        </aside>
    );
}
